// Supermove
import {useMemo} from '@supermove/hooks';

// App
import ProjectWidgetKind from '@shared/modules/Project/enums/ProjectWidgetKind';
import {CommunicationInboxConversationUrlFilterType} from 'modules/Communication/CommunicationInbox/types/CommunicationInboxUrlFilterType';
import {ProjectPageUrlFiltersType} from 'modules/Project/V2/types/ProjectPageUrlFilters';

// There's a bunch of places in the project widgets that reset the URL filters assuming they are controlling everything they need to
// But in the communication inbox, there's some filters that shouldn't reset.
// So this is a compatibility layer to provided a sanitized version of url filters
// It manages these project filters and keeps everything else from being reset.
// section
// block
// widget
// jobUuid
// showCancelledJobs
// workflowRunUuid
// timesheet
export const useCommunicationInboxProjectWidgetUrlFilters = (
  urlFilters: CommunicationInboxConversationUrlFilterType,
) => {
  const modifiedUrlFilters = useMemo(() => {
    const {handleUpdate, ...rest} = urlFilters;

    return {
      ...rest,
      handleUpdate,
      handleReset: (newParams: Partial<ProjectPageUrlFiltersType>) => {
        handleUpdate({
          section: undefined,
          block: undefined,
          //   Using this syntax because if it explicitly calls the widget to be set to undefined we want to close it,
          // but if it doesn't mention it at all, keep on the same widget
          widget:
            'widget' in newParams ? urlFilters.get('widget') : ProjectWidgetKind.PROJECT_DETAILS,
          jobUuid: undefined,
          showCancelledJobs: undefined,
          workflowRunUuid: undefined,
          timesheet: undefined,
          ...newParams,
        });
      },
    };
  }, [urlFilters]);

  return modifiedUrlFilters;
};
